<template>
  <div class="ad-root">
    <img :src="img" >
    <div class="btn-wrap">
      <div class="btn">
        <Button size="large" to="/loans" color="linear-gradient(to right, #4bb0ff, #6149f6)">点我拥有车管家</Button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      img:require('../../assets/images/lipei.png')
    }
  },
  created() {
    document.title = '事故车理赔'
  }
}
</script>

<style lang="less" scoped>
.ad-root {
  position: relative;
  height: 100%;
  overflow: auto;
  img {
    width:100%;
  }
  .btn-wrap {
    // position: fixed;
    // bottom: 20px;
    width: 100%;
    background: #ffffff;
    display: flex;
    justify-content: space-around;
    .btn {
      width: 80%;
      padding: 20px 10px;
    }
  }
}
</style>